import * as React from 'react'
import Piano from './components/Piano'

export const App: React.FunctionComponent = () => {
  return (
    <Piano />
  )
}

export default App
